<template>
  <div>

    <Prompt v-if="!userAgent.android && !userAgent.iOS" :is-shown="true" :is-close-hidden="true">
      <template v-slot:content>
        <div class="title title-style">温馨提示</div>
        <p class="description">请在手机微信/QQ内参与活动</p>
      </template>
    </Prompt>

    <LoginPrompt
      v-if="!userAgent.QQ && !userAgent.weixin && !(loginState && loginState.openid && loginState.openkey) && (userAgent.android || userAgent.iOS)"
      :offer-id="offerId"
      :url="currentLocation"
      :hide-wechat="gameInfo.gameType==gameTypeEnums.PC_GAME"
    ></LoginPrompt>

    <section id="landscape" style="display: none;">
      <img class="phone" src="~2021team-pk-ui/assets/phone.png">
      <p class="desc">为了更好的体验，请将手机竖过来</p>
    </section>

    <Rule v-if="isRuleShown" :is-shown.sync="isRuleShown" :mask-height="maskHeight"></Rule>
    <zone-role 
      v-if="loginState && loginState.openid" 
      :is-shown.sync="isZoneRoleShown"
      :on-select-role="onSelectRole" 
      :mask-height="maskHeight"
    ></zone-role>

    <Lottery 
      :game-info="gameInfo" 
      :key="'lottery_'+item.num" 
      v-for="item in jackpot" 
      :mask-height="maskHeight"
      :on-complete="onLotteryDrawComplete" 
      :lottery-info="lotteryInfo"
      v-if="isLotteryShown && item.num==lotteryInfo.num && gameInfo.luckDrawItem.filter(draw=>draw.num==item.num)[0].type=='square'"
      :is-shown.sync="isLotteryShown" 
      :lottery-id="'lottery_'+item.num"
    ></Lottery>

    <DiscLottery 
      :game-info="gameInfo" 
      :key="'lottery_'+item.num" 
      v-for="item in jackpot" 
      :mask-height="maskHeight"
      :on-complete="onLotteryDrawComplete" 
      :lottery-info="lotteryInfo"
      v-if="isLotteryShown && item.num==lotteryInfo.num && gameInfo.luckDrawItem.filter(draw=>draw.num==item.num)[0].type=='circle'"
      :is-shown.sync="isLotteryShown"
      :lottery-id="'lottery_'+item.num"
    ></DiscLottery>

    <!-- 团队or个人抽奖奖励图片展示 -->
    <AwardDialog
      :game-info="gameInfo" 
      :lottery-info="lotteryInfo"
      v-if="isLotteryShown && (gameInfo.luckDrawItem.filter(draw=> draw.num == currentJackpot.num)[0] && gameInfo.luckDrawItem.filter(draw=> draw.num == currentJackpot.num)[0].type == 'lotteryImg' || lotteryInfo.type == 'goodsImg')"
      :is-shown.sync="isLotteryShown"
    ></AwardDialog>

    <!-- 团队or个人抽奖结果图片展示 -->
    <ReceivedAwardDialog
      :game-info="gameInfo"
      :lottery-info="lotteryInfo"
      v-if="currentAward && (lotteryInfo.type == 'lotteryImg' || lotteryInfo.type == 'goodsImg')"
      :currentAward.sync="currentAward"
    ></ReceivedAwardDialog>

    <Prompt v-if="isPopDialogShown" :is-shown.sync="isPopDialogShown" :is-close-hidden="isPopDialogCloseHidden">
      <template v-slot:content>
        <div class="title title-style">温馨提示</div>
        <p class="description" v-html="popDialogMsg"></p>
      </template>
      <template v-slot:button>
        <div class="tips-btn-t tips-btn-t-style" @click="isPopDialogShown=false">确定</div>
      </template>
    </Prompt>


    <TeamCreate v-if="isTeamCreated" :is-shown.sync="isTeamCreated" :teamShareBg="teamShareBg" :teamShareLogo="teamShareLogo"></TeamCreate>

    <div class="index-container">
      <div class="index-logo" v-if="gameInfo.indexLogos">
        <div class="cont-l">
          <img class="logo-l" :src="gameInfo.indexLogos.business" alt="">
          <img class="logo-r" :src="gameInfo.indexLogos.txcz" alt="">
        </div>
        <div class="cont-r" v-if="pfLogo">
          <img class="logo-w" :src="pfLogo.logo" alt="">
        </div>
      </div>
      <!-- 大区信息 -->
      <div class="area-info">
        <span class="name" v-if="selectedRole && selectedZone" >{{selectedRole.name}}</span>
        <span class="area" v-if="selectedRole && selectedZone">{{selectedZone.zone_name}}</span>
        <a class="more" href="javascript:void 0" @click="showZoneRole" v-if="userAgent.QQ || userAgent.weixin || userAgent.wzyd">切换大区角色&gt;</a>
        <a class="more" href="javascript:void 0" @click="qqConnectSignOut" v-if="showSignOut">注销</a>
      </div>
      <img class="kv" src="~2021team-pk-ui/assets/kv.png" alt="">
      <img class="index-title" src="~2021team-pk-ui/assets/index-title.png" alt="">
      <!-- 时间 -->
      <div class="index-time">
        <div class="time" v-if="period==periodEnums.END">
          活动已结束
        </div>
         <div class="time" v-if="period==periodEnums.NOTSTART">
          活动暂未开启
        </div>
        <div class="time" v-if="period==periodEnums.FORMATION">
          <CountDown v-if="currentPeriodendTime && now" :end-time="currentPeriodendTime/1000" :now="now" count-down-text="组队期倒计时"></CountDown>
        </div>
        <div class="time" v-if="period==periodEnums.PREPARE">
          消耗{{currencyName }}环节 即将开始
          <!-- PK期即将开始 -->
        </div>
        <div class="time" v-else-if="period==periodEnums.PK">
          <CountDown v-if="currentPeriodendTime && now && now<conversionTime" :end-time="conversionTime/1000" :now="now" count-down-text="消费期倒计时"></CountDown>
          <CountDown v-if="currentPeriodendTime && now && now>=conversionTime" :end-time="currentPeriodendTime/1000" :now="now" count-down-text="领奖期倒计时"></CountDown>
        </div>
        <p class="people" v-if="gameInfo.queryParticipant && totalParticipant>0">已有{{totalParticipant}}人参加活动</p>
      </div>
      <!-- 活动规则 -->
      <img class="index-rule" @click="showRule" src="~2021team-pk-ui/assets/index-rule.png" alt="">
      
       <!-- 新版奖池 红包样式-->
      <div class="index-prize index-prize--style">
        <div class="prize-tab" v-if="(jackpot && jackpot.length > 0) || (individualJackpot && individualJackpot.length > 0)">
            <div class="tab-l" :class="{'tab-l-active':prizeTab!=prizeTabEnums.TEAM}" @click="switchPrizeTab(prizeTabEnums.TEAM)">团队任务</div>
            <div class="tab-r" :class="{'tab-r-active':prizeTab==prizeTabEnums.INDIVIDUAL, 'tab-r-icon':individualRedHot}" @click="switchPrizeTab(prizeTabEnums.INDIVIDUAL)">个人任务</div>
        </div>
      </div>
      <!-- 红包背景 -->
      <img v-if="(jackpot && jackpot.length > 0) || (individualJackpot && individualJackpot.length > 0)" class="red-task-bg" src="~2021team-pk-ui/assets/red-task-bg2.png" alt="">
      <!-- 活动流程图 -->
      <div class="red-process">
        <img src="~2021team-pk-ui/assets/red-process.png" alt="">
	  </div> 
      <div class="red-task" v-if="(jackpot && jackpot.length>0) || (individualJackpot && individualJackpot.length>0)">
		<!-- 滑动红包 -->
        <div class="swiper-container swiper-task" v-if="prizeTab == prizeTabEnums.TEAM && jackpot && jackpot.length>0">
            <Swiper :options="giftSwiperOption" ref="teamSwiper" class="swiper-wrapper">
                <Swiper-slide class="swiper-slide" v-for="(item) in jackpot" :key="'jackpot'+item.num">
                    <img src="~2021team-pk-ui/assets/task-red-bg.png" alt="">
                    <p class="giftTxt">{{ item.name }}</p>
                    <div class="describe">
                        <span></span>
                        <div class="txt">累计消耗<p>{{item.num}}<i>{{currencyName}}</i></p>解锁</div>
                        <span></span>
                    </div>
                    <!-- 组队期无状态，不显示标签 -->
                    <!-- <p class="state" v-if="item.status==prizeStatusEnums.AVAILABLE || item.status==prizeStatusEnums.RECEIVED">已达成</p>
                    <p class="state" v-if="item.status==prizeStatusEnums.UNAVAILABLE">未达成</p> -->
                    <!-- <div class="red-btn" v-if="period == periodEnums.PK && currentJackpot.status == prizeStatusEnums.AVAILABLE || currentJackpot.status == prizeStatusEnums.RECEIVED" @click="getPresent(currentJackpot)"></div> -->
                    <!-- <div class="red-btn" v-else @click="showLottery(currentJackpot)"></div> -->
                    <div class="red-btn"></div>
                   	<!-- 人物【抽奖礼包】 -->
					<!-- <img class="man"  :src="item.mainImg" alt="" /> -->
                    <!-- 道具图 -->
                    <div class="list-props-con">
                        <template v-if="item && item.mainImgList && item.mainImgList.length">
                            <div v-for="(mainImg, index) in item.mainImgList" :key="'mainImgList' + index" class="props-con">
                                <!-- 概率 -->
                                <span class="probability"></span>
                                <img :class="['props', item.mainImgClass]" :src="mainImg" alt="">
                            </div>
                        </template>
                        <template v-else>
                            <div class="props-con">
                                <!-- 概率 -->
                                <span class="probability"></span>
                                <img :class="['props', item.mainImgClass]" :src="item.mainImg" alt="">
                            </div>
                        </template>
                    </div>
                    <div class="props-txt-con">
						<p class="props-txt">{{ item.gifttips }}</p>
						<span class="props-tip"><i></i></span>
					</div>
                </Swiper-slide>
            </Swiper>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>

        <!-- 个人奖励tab && 有个人奖励奖池 -->
        <div class="swiper-container swiper-task" v-if="prizeTab == prizeTabEnums.INDIVIDUAL && individualJackpot && individualJackpot.length>0">
            <Swiper :options="giftSwiperOption" ref="individualSwiper" class="swiper-wrapper">
                <Swiper-slide class="swiper-slide swiper-slide-yellow" v-for="(item) in individualJackpot" :key="'jackpot'+item.num">
                    <img src="~2021team-pk-ui/assets/task-yellow-bg.png" alt="">
                    <p class="giftTxt">{{ item.name }}</p>
                    <div class="describe">
                        <span></span>
                        <div class="txt">累计消耗<p>{{item.num}}<i>{{currencyName}}</i></p>解锁</div>
                        <span></span>
                    </div>
                    <!-- 组队期无状态，不显示标签 -->
                    <!-- <p class="state" v-if="item.status==prizeStatusEnums.AVAILABLE || item.status==prizeStatusEnums.RECEIVED">已达成</p>
                    <p class="state" v-if="item.status==prizeStatusEnums.UNAVAILABLE">未达成</p> -->
                    <!-- 开红包的按钮 -->
                    <!-- 消费+领奖期（PK期） && 奖池可领取 or 奖池已领取 -->
                    <!-- <div class="red-btn yellow-btn" v-if="period == periodEnums.PK && currentJackpot.status == prizeStatusEnums.AVAILABLE || currentJackpot.status == prizeStatusEnums.RECEIVED" @click="getIndividualPresent(currentJackpot)"></div> -->
                    <!-- <div class="red-btn yellow-btn" v-else @click="showIndividualPresent(currentJackpot)"></div> -->
                    <div class="red-btn yellow-btn"></div>
                    <!-- 道具图【直增礼包】 -->
					<!-- <img v-if="item.type == 'goodsImg'" class="props" :src="item.mainImg" alt="" /> -->
                     <!-- 人物【抽奖礼包】 -->
					<!-- <img v-else class="man"  :src="item.mainImg" alt="" /> -->
                    <div class="list-props-con">
                        <template v-if="item && item.mainImgList && item.mainImgList.length">
                            <div v-for="(mainImg, index) in item.mainImgList" :key="'mainImgList' + index" class="props-con">
                                <!-- 必得 -->
                                <span class="must" v-if="item.type == 'goodsImg'"></span>
                                <!-- 概率 -->
                                <span class="probability" v-else></span>
                                <img :class="['props', item.mainImgClass]" :src="mainImg" alt="">
                            </div>
                        </template>
                        <template v-else>
                            <div class="props-con">
                                <!-- 必得 -->
                                <span class="must" v-if="item.type == 'goodsImg'"></span>
                                <!-- 概率 -->
                                <span class="probability" v-else></span>
                                <img :class="['props', item.mainImgClass]" :src="item.mainImg" alt="">
                            </div>
                        </template>
                    </div>
                    <div class="props-txt-con">
						<p class="props-txt">{{ item.gifttips }}</p>
						<span class="props-tip"><i></i></span>
					</div>
                </Swiper-slide>
            </Swiper>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>
	  </div>
      <!-- 人物舞台 -->
	  <div class="stage-list" v-if="(prizeTab==prizeTabEnums.TEAM && jackpot && jackpot.length>0) || (prizeTab==prizeTabEnums.INDIVIDUAL && individualJackpot && individualJackpot.length>0)">
	  	<!--舞台  -->
	  	<img class="stage" src="~2021team-pk-ui/assets/stage.png" alt="">
	  	<!-- 按钮 -->
	  	<div class="stage-btns" v-if="currentJackpot && prizeTab==prizeTabEnums.TEAM">
            <!-- PK期（消费期+领奖期）&& 用户达到门槛 -->
            <div 
              v-if="period == periodEnums.PK && currentJackpot.status == prizeStatusEnums.AVAILABLE || currentJackpot.status == prizeStatusEnums.RECEIVED" 
              class="stage-btn stage-btn-l" 
              @click="getPresent(currentJackpot)">
	  		  立即领取
            </div>
            <div v-else class="stage-btn stage-btn-l" @click="showLottery(currentJackpot)">
	  		  查看奖励
            </div>
            <!-- 消费期显示去消费，其他时期去充点券 -->
            <div v-if="period == periodEnums.PK && periodBeforeConversionTime === true" class="stage-btn stage-btn-r" @click="goBuy('consumption')">
	  		  消费{{ currencyName }}
	  		</div>
            <div v-else class="stage-btn stage-btn-r" @click="goBuy">
	  		  去充{{ currencyName }}
	  		</div>
	  	</div>
        <div class="stage-btns" v-if="currentJackpot && prizeTab==prizeTabEnums.INDIVIDUAL">
            <div 
              v-if="period == periodEnums.PK && currentJackpot.status == prizeStatusEnums.AVAILABLE || currentJackpot.status == prizeStatusEnums.RECEIVED" 
              class="stage-btn stage-btn-l" 
              @click="getIndividualPresent(currentJackpot)"
            >
	  		  立即领取
            </div>
            <div v-else class="stage-btn stage-btn-l" @click="showIndividualPresent(currentJackpot)">
	  		  查看奖励
            </div>
            <div  v-if="period == periodEnums.PK && periodBeforeConversionTime === true" class="stage-btn stage-btn-r" @click="goBuy('consumption')">
	  		  消费{{ currencyName }}
	  		</div>
            <div v-else class="stage-btn stage-btn-r" @click="goBuy">
	  		  去充{{ currencyName }}
	  		</div>
	  	</div>
	  	<!-- 小兵 -->
	  	<!-- <div class="army"></div> -->
         <!-- 2023年只保留一个兔子 -->
		<img class="army" src="~2021team-pk-ui/assets/hhswlb.png" v-if="prizeTab == prizeTabEnums.TEAM || prizeTab==prizeTabEnums.INDIVIDUAL" alt="">
        <!-- 虎虎生威 -->
		<!-- <img class="army" src="~2021team-pk-ui/assets/hhswlb.png" v-if="(prizeTab == prizeTabEnums.TEAM && teamActiveSwiperIndex == 3) || (prizeTab==prizeTabEnums.INDIVIDUAL && individualActiveSwiperIndex == 3)" alt=""> -->
		<!-- 心想事成 -->
		<!-- <img class="army" src="~2021team-pk-ui/assets/xxsclb.png" v-if="(prizeTab == prizeTabEnums.TEAM && teamActiveSwiperIndex == 2) || (prizeTab==prizeTabEnums.INDIVIDUAL && individualActiveSwiperIndex == 2)" alt=""> -->
		<!-- 花开富贵 -->
		<!-- <img class="army" src="~2021team-pk-ui/assets/hkfglb.png" v-if="(prizeTab == prizeTabEnums.TEAM && teamActiveSwiperIndex == 1) || (prizeTab==prizeTabEnums.INDIVIDUAL && individualActiveSwiperIndex == 1)" alt=""> -->
		<!-- 恭贺新春 -->
		<!-- <img class="army" src="~2021team-pk-ui/assets/ghxxlb.png" v-if="(prizeTab == prizeTabEnums.TEAM && teamActiveSwiperIndex == 0) || (prizeTab==prizeTabEnums.INDIVIDUAL && individualActiveSwiperIndex == 0)" alt=""> -->
		<!-- 鞭炮 -->
		<div class="firecracker" style="right: 15%;"></div>
	  </div>

      <router-view>
      </router-view>

     <div class="collapse" v-if="period==periodEnums.END">
	  	<h3>谢谢参与<br/>活动已结束</h3>
	  	<p>{{ activityEndCountDown }}秒后自动进入商城</p>
	  </div>

      <!-- 其他精彩活动 -->
      <div class="index index-banner" v-if="adsActivity.length>0">
        <div class="caption">
          <img class="caption-l" src="~2021team-pk-ui/assets/index-title-icon-l.png" alt="">
          其他精彩活动
          <img class="caption-r" src="~2021team-pk-ui/assets/index-title-icon-r.png" alt="">
        </div>
        <div class="banner-con">
          <div class="banner-con-item"  @click="goAds(ad.url)" v-for="ad in adsActivity" :key="ad.url">
            <img :src="ad.img" alt="">
          </div>
        </div>
      </div>

    </div>

    <Toast :toast-msg="toastMsg"></Toast>
    <Present :currency-name="currencyName" :is-shown.sync="individualPresentShown" :present="individualPresentItem" btn-text="确认"></Present>
    <Present
      :currency-name="currencyName" 
      :is-shown.sync="hasReceivedIndividualPresent" 
      :present="individualPresentItem" 
      :btn-text="individualPresentItem.status == prizeStatusEnums.RECEIVED ? '已领取' :'开心收下'"
    ></Present>
    <Loading :isLoading="isLoading" :loadingMsg="loadingMsg"></Loading>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex"
// import "team-pk-ui/ossweb-img/css/index.css"
import "../../../ui/2023_king_newyear/css/style.css"
import "../../../ui/2023_king_newyear/css/swiper.min.css"

import ZoneRole from "./components/ZoneRole.vue"
import Rule from "./components/Rule.vue"
import Lottery from "./components/Lottery.vue"
import DiscLottery from "./components/DiscLottery.vue"
import AwardDialog from "./components/AwardDialog.vue"
import ReceivedAwardDialog from "./components/ReceivedAwardDialog.vue"
import TeamCreate from "./components/TeamCreate.vue"
import * as config from "./config"
import PopDialog from "./components/PopDialog.vue"
import Prompt from "./components/Prompt.vue"
import CountDown from "./components/CountDown.vue"
import Present from "./components/Present.vue"
import Toast from "./components/Toast.vue"
import Loading from "./components/Loading.vue"
import lottryMixin from "./components/lotteryMixin"
import * as urlUtils from "../bargain/utils/url"
import LoginPrompt from "../common/components/LoginPrompt.vue"
import * as request from "../common/utils/request"
import localStorage from "../common/utils/localStorage"
import * as url from "../common/utils/url"
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import { UTC8TimeToTimeStamp } from "../bargain/utils/helper"

let vm = null
export default {
  name: "App",
  components: {
    ZoneRole,
    Rule,
    Lottery,
    TeamCreate,
    PopDialog,
    CountDown,
    DiscLottery,
    AwardDialog,
    ReceivedAwardDialog,
    Toast,
    Prompt,
    LoginPrompt,
    Present,
    Swiper,
    SwiperSlide,
    Loading
  },
  mixins: [lottryMixin],
  mounted() {
    vm = this
    this.getActivity().then(res => {
      let now = this.now

      if (now > UTC8TimeToTimeStamp(this.gameInfo.conversionTime)) {
        this.periodBeforeConversionTime = false
      }
      if (now < UTC8TimeToTimeStamp(this.gameInfo.conversionTime)) {
        this.periodBeforeConversionTime = true
      }

      res.forEach(act => {
        if (+now <= +UTC8TimeToTimeStamp(act.end_time) && +now >= +UTC8TimeToTimeStamp(act.begin_time)) {
          this.period = act.period
          this.currentPeriodendTime = UTC8TimeToTimeStamp(act.end_time).getTime()
        }

        if (act.period == this.periodEnums.PK && +now > UTC8TimeToTimeStamp(act.end_time)) {
          // PK期活动结束
          this.period = this.periodEnums.END
          this.activityEndCalDownTime()
        }

        if (act.period == this.periodEnums.FORMATION && +now < UTC8TimeToTimeStamp(act.begin_time)) {
          // 活动未开始
          this.period = this.periodEnums.NOTSTART
        }
      })
      if (!this.period) {
        this.period = this.periodEnums.PREPARE
      }

      if (this.period !== this.periodEnums.END) {
        // 异步请求base64
        setTimeout(() => {
          urlUtils.getBase64(this.gameInfo?.SHARE_INFO?.POSTER?.IMG || this.teamShareBgIMG).then(res => {
            this.teamShareBg = res
          })

          if (this.gameInfo?.SHARE_INFO?.POSTER?.LOGO) {
            urlUtils.getBase64(this.gameInfo?.SHARE_INFO?.POSTER?.LOGO).then(res => {
              this.teamShareLogo = res
            })
          }
        }, 0)
      }
    })
    let hash = url.getParam("hash")
    if (hash) {
      this.$router.replace(hash)
    }

    window.addEventListener(
      "pageshow",
      e => {
        if (e.persisted) {
          // 从缓存加载
          location.reload()
        }
      },
      false
    )
  },
  data() {
    return {
      isPopDialogCloseHidden: false,
      isPopDialogShown: false,
      popDialogMsg: "",
      popDialogBtnText: "",
      isZoneRoleShown: false,
      isInTeam: "",
      maskHeight: "",
      lotteryInfo: "",
      period: "",
      periodEnums: config.PEROID,
      currentPeriodendTime: "",
      isRuleShown: false,
      isLotteryShown: false,
      prizeStatusEnums: config.PRIZESTATUS,
      toastMsg: "",
      retryCountDown: 10,
      queueTimer: "",
      prizeTab: config.PRIZE_TAB.TEAM,
      prizeTabEnums: config.PRIZE_TAB,
      individualRedHotShown: true,
      hasReceivedIndividualPresent: false,
      individualPresentShown: false,
      individualPresentItem: "",
      gameTypeEnums: config.GAME_TYPE,
      teamActiveSwiperIndex: 0,
      individualActiveSwiperIndex: 0,
      giftSwiperOption: {
        slidesPerView: "auto",
        centeredSlidesBounds: true,
        effect: "coverflow",
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        coverflowEffect: {
          rotate: 0,
          stretch: -1,
          depth: 600,
          modifier: 1,
          slideShadows: false
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        on: {
          slideChange() {
            if (vm.prizeTab == vm.prizeTabEnums.TEAM) {
              vm.teamActiveSwiperIndex = this.realIndex
            }

            if (vm.prizeTab == vm.prizeTabEnums.INDIVIDUAL) {
              vm.individualActiveSwiperIndex = this.realIndex
            }
          },
          click(e) {
            if (e.target && e.target.className && e.target.className.indexOf("red-btn") > -1) {
              if (e.target && e.target.className && e.target.className.indexOf("yellow-btn") > -1) {
                if (
                  (vm.period == vm.periodEnums.PK && vm.currentJackpot.status == vm.prizeStatusEnums.AVAILABLE) ||
                  vm.currentJackpot.status == vm.prizeStatusEnums.RECEIVED
                ) {
                  vm.getIndividualPresent(vm.currentJackpot)
                } else {
                  vm.showIndividualPresent(vm.currentJackpot)
                }
              } else {
                if (
                  (vm.period == vm.periodEnums.PK && vm.currentJackpot.status == vm.prizeStatusEnums.AVAILABLE) ||
                  vm.currentJackpot.status == vm.prizeStatusEnums.RECEIVED
                ) {
                  vm.getPresent(vm.currentJackpot)
                } else {
                  vm.showLottery(vm.currentJackpot)
                }
              }
            }
          }
        },
        teamShareBg: null,
        teamShareLogo: null,
        teamShareBgIMG: require("../../../ui/2022_king_newyear/assets/share_card.png"),
        activityEndCountDown: 5,
        periodBeforeConversionTime: false
      }
    }
  },
  computed: {
    ...mapState([
      "isTeamCreatedShown",
      "selectedZone",
      "selectedRole",
      "jackpot",
      "gameInfo",
      "totalParticipant",
      "userAgent",
      "offerId",
      "individualJackpot",
      "iosRechargeEnable"
    ]),
    ...mapGetters(["loginState", "now", "pf", "isLoading", "loadingMsg"]),
    isTeamCreated: {
      get() {
        return this.isTeamCreatedShown
      },
      set(val) {
        this.setTeamCreatedDialogShown(val)
      }
    },
    currentLocation() {
      return location.href
    },
    adsActivity() {
      // 游戏内||营地 &&不投放游戏内 不展示广告
      return this.gameInfo?.ads?.filter(ads => !((this.userAgent.msdk || this.userAgent.wzyd) && !ads.shownInGame)) || []
    },
    individualRedHot: {
      get() {
        const cacheRedHot = localStorage.get(`team_pk_${this.offerId}_individual_redhot`, true)
        let hasReached
        if (this.individualJackpot) {
          hasReached = this.individualJackpot?.some(item => {
            return item.status == this.prizeStatusEnums.AVAILABLE
          })
        } else {
          hasReached = false
        }

        return hasReached && !cacheRedHot && this.individualRedHotShown
      }
    },
    conversionTime() {
      return UTC8TimeToTimeStamp(this.gameInfo.conversionTime).getTime()
    },
    currencyName() {
      return this.gameInfo.shop.currency
    },
    pfLogo() {
      return this.gameInfo.indexLogos.pflogo?.find(item => item.pf == this.pf)
    },
    showSignOut() {
      return this.userAgent.weixin && this.gameInfo.gameType == config.GAME_TYPE.PC_GAME && window?.QC?.Login.check()
    },
    currentJackpot() {
      if (this.prizeTab == this.prizeTabEnums.TEAM) {
        if (this.jackpot?.length) {
          return this.jackpot[this.teamActiveSwiperIndex]
        }
      }

      if (this.prizeTab == this.prizeTabEnums.INDIVIDUAL) {
        if (this.individualJackpot?.length) {
          return this.individualJackpot[this.individualActiveSwiperIndex]
        }
      }
    }
  },
  methods: {
    ...mapActions([
      "setTeamCreatedDialogShown",
      "getTeamPresent",
      "reportUserAction",
      "getLuckCoupon",
      "getDrawList",
      "getLuckDrawAward",
      "getActivity",
      "reveiveIndividualTaskPresent",
      "getOpenlink",
      "jumpToMqq",
      "qqConnectSignIn",
      "luckyDraw",
      "setLoading",
      "checkIosWhiteListRecharge"
    ]),
    persistIndividualRedHot(val) {
      localStorage.set(`team_pk_${this.offerId}_individual_redhot`, val || "")
      this.individualRedHotShown = false
    },
    handleError(res) {
      clearInterval(this.queueTimer)
      let msg = `系统繁忙，请稍后再试！${res.ret ? `(${res.ret})` : ""}`
      if (res?.err_code == "1211-11-0") {
        this.setToastMsg(`消费≥1${this.currencyName}的成员才可领取奖励哦~`)
        return
      } else if (res && res.msg && res.err_code == "") {
        this.isPopDialogCloseHidden = false
        msg = res.msg
        this.popDialogMsg = msg
      } else {
        this.retryCountDown = 10
        msg = `哎呀，活动太火爆啦！排队进入${this.retryCountDown}……`
        this.popDialogMsg = msg
        this.queueTimer = setInterval(() => {
          this.retryCountDown--
          msg = `哎呀，活动太火爆啦！排队进入${this.retryCountDown}……`
          this.popDialogMsg = msg
          if (this.retryCountDown == 0) {
            this.isPopDialogShown = false
            clearInterval(this.queueTimer)
          }
        }, 1000)
        this.isPopDialogCloseHidden = true
      }
      this.isPopDialogShown = true
    },
    switchPrizeTab(tab) {
      if (this.prizeTab == tab) return

      this.prizeTab = tab

      if (tab == this.prizeTabEnums.TEAM) {
        this.$nextTick(() => {
          this.$refs.teamSwiper?.$swiper?.loopDestroy()
          this.$refs.teamSwiper?.$swiper?.loopCreate()
          this.$refs.teamSwiper?.$swiper?.update()
          this.$refs.teamSwiper?.$swiper?.slideTo(this.teamActiveSwiperIndex)
          this.$refs.teamSwiper?.$swiper?.slideToLoop(this.teamActiveSwiperIndex)
        })
      }

      if (tab == this.prizeTabEnums.INDIVIDUAL) {
        this.$nextTick(() => {
          this.$refs.individualSwiper?.$swiper?.loopDestroy()
          this.$refs.individualSwiper?.$swiper?.loopCreate()
          this.$refs.individualSwiper?.$swiper?.update()
          this.$refs.individualSwiper?.$swiper?.slideTo(this.individualActiveSwiperIndex)
          this.$refs.individualSwiper?.$swiper?.slideToLoop(this.individualActiveSwiperIndex)
        })
      }
    },
    showZoneRole() {
      this.isZoneRoleShown = true
      this.maskHeight = document.documentElement.scrollHeight
      this.reportUserAction({
        iformat: config.REPORT.CLICK.CHANGE_ROLE
      })
    },
    onSelectRole() {},
    showRule() {
      this.isRuleShown = true
      // this.setMaskShowStatus(true)
      this.maskHeight = document.documentElement.scrollHeight
      this.reportUserAction({
        iformat: config.REPORT.CLICK.RULE
      })
    },

    /**
     * 展示抽奖奖励内容
     */
    showLottery(info) {
      // this.getDrawList({ num: info.num })
      if (this.selectedZone && this.selectedRole) {
        let presentConfig = this.gameInfo.luckDrawItem.filter(luck => luck.num == info.num)[0]
        if (!presentConfig) {
          console.error("抽奖配置有问题！请检查！")
          return
        }
        info = {
          ...presentConfig,
          ...info
        }

        this.lotteryInfo = info
        this.isLotteryShown = true
        this.maskHeight = document.documentElement.scrollHeight
      } else {
        this.showZoneRole()
      }
      if (!info.status || info.status == this.prizeStatusEnums.LOCKED) {
        this.reportUserAction({
          iformat: config.REPORT.CLICK.CHECK_LOTTERY,
          resultInfo: info
        })
      } else if (info.status == this.prizeStatusEnums.UNAVAILABLE) {
        this.reportUserAction({
          iformat: config.REPORT.CLICK.LOTTERY_UNREACH,
          resultInfo: info
        })
      }
    },
    /**
     * 展示道具奖励内容
     */
    showGoodsAwardList(info) {
      this.lotteryInfo = info
      this.isLotteryShown = true

      this.reportUserAction({
        iformat: config.REPORT.CLICK.CHECK_LOTTERY,
        resultInfo: info
      })
    },
    /**
     * 展示道具奖励结果
     */
    showGoodsAwardResult(award, currentAward = null) {
      this.lotteryInfo = award
      if (currentAward) {
        this.currentAward = currentAward
      } else {
        this.currentAward = {
          url: award.resultImg,
          name: award.resultName
        }
      }
    },
    onLotteryDrawComplete() {
      console.log("中奖了") //
    },
    getQualification(item) {
      this.setLoading(true)
      this.isRequesting = true
      this.getLuckCoupon({ num: item.num })
        .then(res => {
          this.setLoading(false)
          this.isRequesting = false
          // 弹出抽奖弹窗
          let qualification = res?.luckdraw_info?.luck_mpinfo?.coupon
          if (qualification.length > 0) {
            item.qualification = qualification
            if (item.type == "lotteryImg") {
              // 有抽奖券 且 为img类型，则自动帮用户抽奖
              this.lotteryInfo = item
              this.autoLuckDraw(item)
            } else {
              this.showLottery(item)
            }
          } else {
            this.setToastMsg("系统繁忙，请稍后再试！")
          }
        })
        .catch(res => {
          this.setLoading(false)
          this.isRequesting = false
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.GET_DRAW_QUALIFICATION_ERROR,
            resultInfo: res
          })
          this.handleError(res)
        })
    },
    getPresent(item) {
      if (this.isRequesting) {
        return
      }
      this.reportUserAction({
        iformat: config.REPORT.CLICK.LOTTERY_RECEIVE,
        resultInfo: item
      })

      let presentConfig = this.gameInfo.luckDrawItem.filter(luck => luck.num == item.num)[0]
      if (!presentConfig) {
        console.error("抽奖配置有问题！请检查！")
        return
      }

      item = {
        ...presentConfig,
        ...item
      }

      // 如果是img类型的抽奖（即自动给用户抽奖，展示结果和奖池图片），则优先确认用户选中了角色
      if (item.type == "lotteryImg" && (!this.selectedZone || !this.selectedRole)) {
        this.showZoneRole()
        return
      }

      this.setLoading(true)
      this.isRequesting = true
      // 查券
      this.getLuckCoupon({ num: item.num })
        .then(res => {
          this.setLoading(false)
          this.isRequesting = false

          let qualification = res?.luckdraw_info?.luck_mpinfo?.coupon
          if (qualification.length > 0) {
            //当前用户拿到了抽奖资格，可以直接弹出抽奖去抽
            item.qualification = qualification
            if (item.type == "lotteryImg") {
              // 有抽奖券 且 为img类型，则自动帮用户抽奖
              this.lotteryInfo = item
              this.autoLuckDraw(item)
            } else {
              this.showLottery(item)
            }
          } else {
            this.setLoading(true)
            //没有，有可能是已经领过奖品，也可能是抽奖券还没领
            //查用户是否有奖品
            this.isRequesting = true
            this.getLuckDrawAward({
              num: item.num
            })
              .then(res => {
                this.setLoading(false)
                this.isRequesting = false
                // 有奖品展示奖品
                let count = res.luckdraw_info.luck_mpinfo.total_num
                if (count > 0) {
                  item.status = this.prizeStatusEnums.RECEIVED
                  if (item.type == "lotteryImg") {
                    this.showGoodsAwardResult(item, res.luckdraw_info.luck_mpinfo.award[0])
                  } else {
                    item.award = res.luckdraw_info.luck_mpinfo.award
                    this.showLottery(item)
                  }
                } else {
                  // 没有奖品，领取团队奖励，以防后台没有自动赠送抽奖券
                  this.setLoading(true)
                  this.isRequesting = true
                  this.getTeamPresent(item.num)
                    .then(() => {
                      this.setLoading(false)
                      this.isRequesting = false
                      // 领取成功弹出抽奖框去抽奖
                      this.getQualification(item)
                    })
                    .catch(res => {
                      this.setLoading(false)
                      this.isRequesting = false
                      this.reportUserAction({
                        iformat: config.REPORT.PAGEVIEW.GET_LUCKY_COUPON_ERROR,
                        resultInfo: res
                      })
                      this.handleError(res)
                    })
                }
              })
              .catch(res => {
                this.setLoading(false)
                this.isRequesting = false
                //这里查询异常上报一下
                this.reportUserAction({
                  iformat: config.REPORT.PAGEVIEW.QUERY_TEAM_PRESENT_ERROR,
                  resultInfo: res
                })
                this.handleError(res)
              })
            // this.coupon[index].status = this.prizeStatusEnums.RECEIVED
          }
        })
        .catch(res => {
          this.setLoading(false)
          this.isRequesting = false
          //这里查询异常上报一下
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.GET_DRAW_QUALIFICATION_ERROR,
            resultInfo: res
          })
          this.handleError(res)
        })

      // if (item.qualification && item.qualification.length > 0) {
      //   //当前用户拿到了抽奖资格，可以直接弹出抽奖去抽
      //   this.showLottery(item)
      // } else {
      //   this.getTeamPresent(item.num)
      //     .then(() => {
      //       //todo
      //       // 领取成功先去查用户抽奖券的id
      //       this.getQualification(item)
      //     })
      //     .catch(res => {
      //       if (res && res.err_code == "1132-2007018-0") {
      //         //用户领过抽奖券弹出抽奖弹框
      //
      //         this.getQualification(item)
      //       } else {
      //         this.reportUserAction({
      //           iformat: config.REPORT.PAGEVIEW.GET_LUCKY_COUPON_ERROR,
      //           resultInfo: res
      //         })
      //         this.handleError(res)
      //       }
      //     })
      // }
    },
    goBuy(type = "") {
      if (this.gameInfo.gameType != this.gameTypeEnums.PC_GAME) {
        if (type == "consumption") {
          // 消费
          if (this.userAgent.QQ || this.userAgent.weixin) {
            this.goShop()
          } else if (this.userAgent.wzyd) {
            this.goShop(true)
          } else {
            this.popupRechargeOrConsumptionDialog(type)
          }
        } else {
          // 充值
          if (this.userAgent.msdk || this.userAgent.weixinminiprogram) {
            this.popupRechargeOrConsumptionDialog(type)
          } else if (this.userAgent.wzyd || this.userAgent.QQ || this.userAgent.weixin) {
            if (this.userAgent.iOS) {
              // 判断ip白名单
              this.setLoading(true)
              this.checkIosWhiteListRecharge()
                .then(() => {
                  this.setLoading(false)
                  if (this.iosRechargeEnable[`${this.offerId}_${this.loginState.openid}`]) {
                    this.goShop(this.userAgent.wzyd ? true : false)
                  } else {
                    this.popupRechargeOrConsumptionDialog(type)
                  }
                })
                .catch(err => {
                  console.log(err)
                  this.setLoading(false)
                  // 白名单请求报错默认黑名单
                  this.popupRechargeOrConsumptionDialog(type)
                })
            } else {
              this.goShop(this.userAgent.wzyd ? true : false)
            }
          }
        }
      } else if (this.loginState?.openid && this.loginState.openkey) {
        location.href = `https://pay.qq.com/h5/shop.shtml?${request.serializeParams({
          pf: this.pf || "__mds_activity_pk",
          openid: this.loginState.openid,
          openkey: this.loginState.openkey,
          sessionid: this.loginState.session_id,
          sessiontype: this.loginState.session_type,
          wxAppid2: this.loginState.wx_appid || "",
          qq_appid: this.loginState.qq_appid || ""
        })}#/order/${this.gameInfo.shop.bizId}/biz/${this.gameInfo.shop.busId}?serviceZone=1`
      } else {
        this.popupRechargeOrConsumptionDialog(type)
      }
    },
    popupRechargeOrConsumptionDialog(type) {
      this.isPopDialogShown = true
      this.popDialogMsg = type == "consumption" ? "请前往游戏商城消费&nbsp;" : `请前往游戏充值${this.currencyName}<br/>&nbsp;`
    },
    activityEndCalDownTime() {
      this.activityEndCountDown = 5
      let queueTimer = setInterval(() => {
        this.activityEndCountDown--
        if (this.activityEndCountDown == 0) {
          this.goShop()
          clearInterval(queueTimer)
        }
      }, 1000)
    },
    goShop(carrayLoginState = false) {
      let iOSPf = "__mds_aW9zd2hpdGVsaXN0_huodong_20230114"
      let shopLink = `https://pay.qq.com/h5/shop.shtml?pf=${this.userAgent.iOS ? iOSPf : this.pf || "__mds_activity_pk"}#/order/${
        this.gameInfo.shop.bizId
      }/biz/${this.gameInfo.shop.busId}?serviceZone=1`
      if (carrayLoginState) {
        shopLink = `https://pay.qq.com/h5/shop.shtml?${request.serializeParams({
          pf: this.userAgent.iOS ? iOSPf : this.pf || "__mds_activity_pk",
          openid: this.loginState.openid,
          openkey: this.loginState.openkey,
          sessionid: this.loginState.session_id,
          sessiontype: this.loginState.session_type,
          wxAppid2: this.loginState.wx_appid || "",
          qq_appid: this.loginState.qq_appid || ""
        })}#/order/${this.gameInfo.shop.bizId}/biz/${this.gameInfo.shop.busId}?serviceZone=1`
      }
      location.href = shopLink
    },
    redirect(url) {
      if (this.loginState.accountType == "qq") {
        this.jumpToMqq(url)
      } else {
        this.getOpenlink(url)
          .then(openlink => {
            location.href = openlink
          })
          .catch(res => {
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.GET_OPENLINK_ERROR,
              resultInfo: res
            })
            this.setToastMsg("系统繁忙，请稍候再试！")
          })
      }
    },
    goAds(url) {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.BANNER
      })
      if (url) {
        let new_url = urlUtils.delParam(["pf"], url)
        let queryStr = new_url.split("?")[1] || ""
        if (this.userAgent.QQ || this.userAgent.weixin) {
          location.href = `${new_url}${new_url.indexOf("?") > -1 ? "&" : "?"}pf=${this.pf || "__mds_activity_pk"}`
        } else if (this.userAgent.msdk || this.userAgent.wzyd) {
          this.redirect(`${new_url}${new_url.indexOf("?") > -1 ? "&" : "?"}pf=${this.pf || "__mds_activity_pk"}`)
        } else if (this.loginState?.openid && this.loginState?.openkey) {
          location.href = `${new_url}${new_url.indexOf("?") > -1 ? "&" : "?"}${request.serializeParams({
            pf: this.pf || "__mds_activity_pk",
            openid: this.loginState.openid,
            openkey: this.loginState.openkey,
            sessionid: this.loginState.session_id,
            sessiontype: this.loginState.session_type,
            wxAppid2: this.loginState.wx_appid || "",
            qq_appid: this.loginState.qq_appid || ""
          })}&${queryStr}`
        } else {
          this.redirect(`${new_url}${new_url.indexOf("?") > -1 ? "&" : "?"}pf=${this.pf || "__mds_activity_pk"}`)
        }
      } else {
        this.setToastMsg("请在游戏活动面板参与活动")
      }
    },
    showIndividualPresent(item) {
      if (item.type == "coupon") {
        if (this.userAgent.QQ || this.userAgent.weixin || (this.loginState.openid && this.loginState.openkey)) {
          location.href = item.url
        } else if (this.userAgent.msdk) {
          location.href = `${item.url}&${urlUtils.delParam("pf", location.search.substr(1))}`
        } else {
          this.redirect(item.url)
        }
      } else if (item.type == "lotteryImg") {
        this.showLottery(item)
      } else if (item.type == "goodsImg") {
        this.showGoodsAwardList(item)
      } else if (item.type == "goods") {
        this.individualPresentShown = true
        this.individualPresentItem = item
      }
    },
    getIndividualPresent(item) {
      if (this.selectedZone && this.selectedRole) {
        if (this.isReveivingIndividualTaskPresent) {
          return
        }
        this.isReveivingIndividualTaskPresent = true
        this.setLoading(true)
        this.reveiveIndividualTaskPresent(item.num)
          .then(() => {
            this.setLoading(false)
            this.isReveivingIndividualTaskPresent = false
            if (item.type == "coupon") {
              if (this.userAgent.QQ || this.userAgent.weixin) {
                location.href = item.url
              } else if (this.userAgent.msdk) {
                location.href = `${item.url}&${urlUtils.delParam("pf", location.search.substr(1))}`
              } else {
                this.redirect(item.url)
              }
            } else if (item.type == "lotteryImg") {
              this.getPresent(item)
            } else if (item.type == "goodsImg") {
              this.showGoodsAwardResult(item)
            } else {
              this.hasReceivedIndividualPresent = true
              this.individualPresentItem = item
            }
            this.persistIndividualRedHot(true)
          })
          .catch(res => {
            this.setLoading(false)
            this.isReveivingIndividualTaskPresent = false
            if (item.type == "coupon") {
              if (this.userAgent.QQ || this.userAgent.weixin) {
                location.href = item.url
              } else if (this.userAgent.msdk) {
                location.href = `${item.url}&${urlUtils.delParam("pf", location.search.substr(1))}`
              } else {
                this.redirect(item.url)
              }
            } else if (item.type == "lotteryImg") {
              if (res.multi_err == "1132-91001-0") {
                this.getPresent(item)
              } else {
                this.setToastMsg("系统繁忙，请稍后再试！")
                this.reportUserAction({
                  iformat: config.REPORT.PAGEVIEW.GET_INDIVIDUAL_PRIZE_ERROR,
                  resultInfo: res
                })
              }
            } else if (item.type == "goods") {
              if (res.multi_err == "1132-91001-0") {
                // this.setToastMsg("您已领取过该奖励哦~")
                item.status = this.prizeStatusEnums.RECEIVED
                this.hasReceivedIndividualPresent = true
                this.individualPresentItem = item
              } else {
                this.setToastMsg("系统繁忙，请稍后再试！")
                this.reportUserAction({
                  iformat: config.REPORT.PAGEVIEW.GET_INDIVIDUAL_PRIZE_ERROR,
                  resultInfo: res
                })
              }
            } else if (item.type == "goodsImg") {
              if (res.multi_err == "1132-91001-0") {
                // this.setToastMsg("您已领取过该奖励哦~")
                item.status = this.prizeStatusEnums.RECEIVED
                this.showGoodsAwardResult(item)
              } else {
                this.setToastMsg("系统繁忙，请稍后再试！")
                this.reportUserAction({
                  iformat: config.REPORT.PAGEVIEW.GET_INDIVIDUAL_PRIZE_ERROR,
                  resultInfo: res
                })
              }
            }
          })
      } else {
        this.showZoneRole()
      }
    },
    checkIndividualPresent(item) {
      if (item.type == "coupon") {
        if (this.userAgent.QQ || this.userAgent.weixin) {
          location.href = item.url
        } else if (this.userAgent.msdk) {
          location.href = `${item.url}&${urlUtils.delParam("pf", location.search.substr(1))}`
        } else {
          this.redirect(item.url)
        }
      } else {
        this.showIndividualPresent(item)
      }
    },
    setToastMsg(msg) {
      this.toastMsg = msg
      setTimeout(() => {
        this.toastMsg = ""
      }, 2000)
    },
    qqConnectSignOut() {
      window.QC.Login.signOut()
      this.qqConnectSignIn()
    }
  }
}
</script>

<style scoped>
</style>
